import { connect } from 'react-redux';
import { UserLeavePolicies } from '../Attendance/LeavePolicies';
import { EmployeeLeavesAndHolidays } from '../Attendance/LeavesAndHolidays';
import UserProfile from '../index';

interface Props {
  userId: string;
  role: string;
}

const LeavesPage = ({ userId, role }: Props) => {
  return (
    <UserProfile>
      <div className="mt-4 p-4 space-y-6">
        <UserLeavePolicies userId={userId} role={role} />
        <EmployeeLeavesAndHolidays userId={userId} role={role} showBalances={false} />
      </div>
    </UserProfile>
  );
};

const mapStateToProps = (state: any) => ({
  userId: state.user.userId,
  role: state.user.role,
});

export default connect(mapStateToProps)(LeavesPage);
